// extracted by mini-css-extract-plugin
module.exports = {"timer":"_67iqAX","circle":"_1GMfVB"};